import React, { ChangeEvent, Dispatch, SetStateAction } from 'react';
import styles from './SearchInput.module.css';

type Props = {
  inputValue: string;
  handleInputChange: (e: ChangeEvent<HTMLInputElement>) => void;
};

const SearchInput = ({ inputValue, handleInputChange }: Props) => {
  return (
    <div className={styles.wrapper}>
      <input
        type="text"
        placeholder="Поиск"
        className={styles.input}
        id="input"
        value={inputValue}
        onChange={handleInputChange}
      />
      <label htmlFor="input" className={styles.label}>
        введите слово или термин
      </label>
    </div>
  );
};

export default SearchInput;
